
$(document).ready(function() {
  // Shop page collection title margin

  const pageLeft = document.querySelector(".page-left");
  const pageRight = document.querySelector(".page-right");
  const jumpLeft = document.querySelector(".jump-1");
  const jumpRight = document.querySelector(".jump-2");

  const options = {
    // threshold: 0,
  };
  

  const observerLeft = new IntersectionObserver(
    function(entries, observer) {
    entries.forEach(entry => {
      // // console.log(entry);
      if(entry.isIntersecting) {
        jumpLeft.style.display = 'none';
        return;
      } else {
        jumpLeft.style.display = 'block';
      };
    });
  }, options);

  observerLeft.observe(pageLeft);

    const observerRight = new IntersectionObserver(
    function(entries, observer) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        // console.log("pageRight visible");
        jumpRight.style.display = "none";
      } else {
        // console.log("pageRight hidden");
        jumpRight.style.display = "block";
      };
      // console.log(entry.target.querySelector('div.jump-link'));

      // if(entry.target.isIntersecting) {
      //   entry.target.querySelector('div.jump-link').style.display = 'block';
      // } else {
      //   entry.target.querySelector('div.jump-link').style.display = 'none';
      // };

      // if(entry.target.querySelector('div.jump-link').isIntersecting) {
      //   document.querySelector('div.page-left div.jump-link').style.display = 'none';
      //   return;
      // } else {};
    });
  }, options);

  observerRight.observe(pageRight);


    const observerJumpRight = new IntersectionObserver(
    function(entries, observer) {
    entries.forEach(entry => {
      // // console.log(entry);
      if(entry.isIntersecting) {
        jumpLeft.style.display = 'none';
        return;
      } else {
        jumpLeft.style.display = 'block';
      };
    });
  }, options);

  observerLeft.observe(jumpRight);



});